import { createContext, useContext } from "react";
import { useLocation } from "react-router-dom";

import useScrollBehavior from "../hooks/useScrollBehavior";

const defaultScrollBehavior = {
  y: 0,
  previousY: 0,
  delta: 0,
  direction: "none",
  threshold: 24,
  minDelta: 5,
  isPastThreshold: false,
  isScrollingDown: false,
  isScrollingUp: false,
  hiddenByScroll: false,
};

export const ScrollBehaviorContext = createContext(defaultScrollBehavior);

export function ScrollBehaviorProvider({ children, options }) {
  const location = useLocation();
  const resetKey = `${location.pathname}${location.search}`;
  const scrollBehavior = useScrollBehavior({
    ...options,
    resetKey: options?.resetKey ?? resetKey,
  });

  return (
    <ScrollBehaviorContext.Provider value={scrollBehavior}>
      {children}
    </ScrollBehaviorContext.Provider>
  );
}

export function useScrollBehaviorContext() {
  return useContext(ScrollBehaviorContext);
}
